import { CardDataType, type CardData, ComponentName } from "../types";

export class TabsGenresCardData implements CardData {

    constructor(
        private readonly itemClass: string,
        private readonly caption: string | null,
        private readonly index: number,
        private readonly genreId: string,
        private readonly isPremium: boolean,
    ) { }

    getId(): string {
        return `${this.index}`;
    }

    getClass(): string {
        return this.itemClass;
    }

    getType(): CardDataType {
        return CardDataType.TabsGenres;
    }

    getComponentName(): ComponentName {
        return ComponentName.TABS_GENRES;
    }

    getCaption(): string | null {
        return this.caption;
    }

    getGenreId(): string {
        return this.genreId;
    }

    getIsPremium(): boolean {
        return this.isPremium;
    }
}